import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isString from "lodash/isString";
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import { Button } from "../../Button/Button/Button";
import { CollapsiblePanel } from "../../CollapsiblePanel/CollapsiblePanel";
import Colors from "../../Color/Colors";
import Utility from "../../Utility/Utility";
import styles from "./MobileMenuItem.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileMenuItem = function MobileMenuItem(_ref) {
  var menuItem = _ref.menuItem,
    _ref$subMenu = _ref.subMenu,
    subMenu = _ref$subMenu === void 0 ? [] : _ref$subMenu,
    _ref$subMenuItem = _ref.subMenuItem,
    subMenuItem = _ref$subMenuItem === void 0 ? false : _ref$subMenuItem,
    _ref$closeSubMenuLabe = _ref.closeSubMenuLabel,
    closeSubMenuLabel = _ref$closeSubMenuLabe === void 0 ? 'Click to close {{link}} submenu' : _ref$closeSubMenuLabe,
    _ref$openSubMenuLabel = _ref.openSubMenuLabel,
    openSubMenuLabel = _ref$openSubMenuLabel === void 0 ? 'Click to open {{link}} submenu' : _ref$openSubMenuLabel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    isHovered = _useState2[1];
  var onMouseEnter = function onMouseEnter() {
    isHovered(true);
  };
  var onMouseLeave = function onMouseLeave() {
    isHovered(false);
  };
  var getTokenLabel = function getTokenLabel(label) {
    return Utility.parseInterpolationParams(label, {
      link: (menuItem === null || menuItem === void 0 ? void 0 : menuItem.text) || ''
    });
  };
  var _ref2 = menuItem || {},
    active = _ref2.active,
    activeTrail = _ref2.activeTrail,
    attributes = _ref2.attributes,
    icon = _ref2.icon,
    iconHover = _ref2.iconHover,
    text = _ref2.text,
    subtitle = _ref2.subtitle,
    title = _ref2.title,
    url = _ref2.url,
    newWindow = _ref2.newWindow,
    noFill = _ref2.noFill;
  var isLink = url && url.length !== 0;
  var isSubMenu = subMenu && subMenu.length !== 0;
  var itemInner = function itemInner() {
    var renderedChildren = Utility.dangerousHTML(text);
    var renderedChildrenSubtitle = Utility.dangerousHTML(subtitle);
    return /*#__PURE__*/_jsxs("span", {
      className: classnames(styles.innerWrapper, {
        [styles.innerWrapperWithIcon]: icon,
        [styles.flexColumn]: subtitle
      }),
      children: [icon && /*#__PURE__*/_jsx("span", {
        className: styles.iconWrapper,
        children: /*#__PURE__*/_jsx(Icon, {
          type: hovered && iconHover ? iconHover : icon,
          width: "20px",
          height: "20px",
          fill: Colors.colorWW100,
          noFill: noFill
        })
      }), /*#__PURE__*/_jsx("span", {
        className: subMenuItem ? styles.subMenuText : '',
        children: renderedChildren
      }), /*#__PURE__*/_jsx("span", {
        className: subtitle ? styles.subtitle : '',
        children: renderedChildrenSubtitle
      })]
    });
  };
  var primaryMobileMenuItem = text && /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx(Button, {
      className: classnames(styles.link, {
        [styles.subLink]: subMenuItem,
        [styles.linkActive]: active,
        [styles.linkActiveTrail]: activeTrail
      }),
      type: "no-style",
      url: url,
      accessibilityLabel: Utility.getLinkTitleText(text, title),
      newWindow: newWindow,
      attributes: attributes,
      children: itemInner()
    })
  });
  var secondaryMobileMenuItems = isSubMenu && subMenu.map(function (secondaryMobileMenuItem, i) {
    return /*#__PURE__*/_jsx(MobileMenuItem, {
      menuItem: secondaryMobileMenuItem,
      subMenuItem: true
    }, i);
  });

  // Use correct element based on if subitem or not.
  var ContainerTag = subMenuItem ? 'li' : 'div';
  var labelClose = getTokenLabel(closeSubMenuLabel);
  var labelOpen = getTokenLabel(openSubMenuLabel);
  return /*#__PURE__*/_jsxs(ContainerTag, {
    className: styles.container,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: [!isSubMenu && primaryMobileMenuItem, isSubMenu && /*#__PURE__*/_jsx("div", {
      className: styles.collapsible,
      children: /*#__PURE__*/_jsx(CollapsiblePanel, {
        collapsed: true,
        collapsible: true,
        active: active,
        activeTrail: activeTrail,
        iconPosition: isLink ? undefined : 'right',
        buttonAttributes: attributes,
        buttonStyle: isLink ? 'primary--with-link' : 'primary',
        buttonText: itemInner(),
        buttonUrl: url,
        buttonNewWindow: newWindow,
        labels: {
          close: _isString(labelClose) ? labelClose : '',
          open: _isString(labelOpen) ? labelOpen : ''
        },
        flexEndToggleButton: true,
        children: /*#__PURE__*/_jsx("ul", {
          className: styles.subMenu,
          children: secondaryMobileMenuItems
        })
      })
    })]
  });
};